var _style, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtcodeySymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;opacity:0.17;fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000025417090828857401590000002133338951813455517_);}\n\t.st2{opacity:0.17;fill:url(#SVGID_00000113351145536878099820000013318116609944854688_);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.24;fill:url(#SVGID_00000101090938969450488090000010353871366673313155_);}\n\t.st5{display:none;}\n\t.st6{fill:url(#SVGID_00000068675819001203370480000005902187541637289917_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.9634,
    y1: 15.9094,
    x2: 47.9288,
    y2: 35.6733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05825046,
    style: {
      stopColor: "#532BEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED34B3"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.8,22.9c0-10.7-7.6-19.7-17.6-21.8c-0.8,0.3-1.5,0.5-2,0.7c-4,1.9-3.9,7.9-3,8.5C24.1,10.9,40,23,40.3,21 c0.2-2-0.7,8.3,2.9,13.9c1,1.5,1.9,2.9,2.6,4.1V22.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018215495980056167570000009425191118050115511_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.0399,
    y1: 15.8227,
    x2: 50.4489,
    y2: 32.1316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#23007E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D0381"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018215495980056167570000009425191118050115511_)"
    },
    d: "M45.8,22.9v0.2c0,0.2,0,0.4,0,0.7V46 c-3.7,0-6.9-2.3-8.2-5.5c-3.8,3.1-8.8,5-14.1,5h-0.2c-12.3,0-22.4-10-22.4-22.4v-0.2c0-12.3,10-22.4,22.4-22.4h0.2 C35.8,0.5,45.8,10.6,45.8,22.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026862125831709277240000003287302364899629501_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.3614,
    y1: 14.9156,
    x2: 46.5186,
    y2: 33.3446
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05825046,
    style: {
      stopColor: "#532BEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED34B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.17,
      fill: "url(#SVGID_00000026862125831709277240000003287302364899629501_)"
    },
    d: "M45.8,23.8 c0-0.2,0-0.4,0-0.7v-0.2c0-0.2,0-0.4,0-0.5c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3-0.1-0.4 c0,0,0-0.1,0-0.1c0-0.2-0.1-0.3-0.1-0.5c0,0,0-0.1,0-0.1c0-0.1,0-0.3-0.1-0.4c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2-0.1-0.3 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2-0.1-0.3c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3 c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.3-0.1-0.4c0,0,0-0.1,0-0.1c-0.1-0.2-0.1-0.3-0.2-0.5c0-0.1,0-0.1-0.1-0.2 c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3 c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.1-0.1-0.2 c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.1-0.1-0.3-0.2-0.4c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.2 c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.3-0.3-0.4c0,0,0,0,0,0 C41.1,9.1,41,9,40.8,8.9c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.1-0.2-0.2-0.2c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.1-0.2-0.2-0.2 c0,0-0.1-0.1-0.1-0.1C40,7.9,40,7.8,39.9,7.8c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.1-0.2-0.2-0.2c0,0-0.1-0.1-0.1-0.1 c-0.4-0.4-0.8-0.8-1.3-1.2c0,0,0,0,0,0C38.1,6,38,5.9,37.9,5.8c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.2c0,0-0.1,0-0.1-0.1 c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0-0.1,0c-0.7-0.6-1.5-1.1-2.3-1.5c0,0,0,0,0,0c-0.1-0.1-0.2-0.1-0.4-0.2c0,0,0,0,0,0 c-0.5-0.3-1-0.5-1.4-0.7c0,0,0,0,0,0c-0.5-0.2-1-0.4-1.5-0.6c0,0,0,0,0,0c-0.5-0.2-1-0.4-1.6-0.5c0,0,0,0,0,0 c-0.5-0.2-1.1-0.3-1.6-0.4c0,0,0,0,0,0c-0.8,0.3-1.5,0.5-2,0.7c-4,1.9-3.9,7.9-3,8.5c0.8,0.6,14.4,10.8,16.7,11 c-0.8,1.8-2.5,8.7,2.9,13c1.4,1.2,2.4,1.5,3,1.3V23.8z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 23.3,
    cy: 22.9,
    r: 14.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093178623663669698340000003192194767718417338_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.8962,
    y1: 25.8317,
    x2: 11.8947,
    y2: 25.8317
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#534BEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED34B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "url(#SVGID_00000093178623663669698340000003192194767718417338_)"
    },
    d: "M6,26.9 c-0.5-0.1-1-0.3-1.5-0.6c-1.3-0.9-2.1-2.3-2.1-4c0-1.4,0.7-2.7,1.7-3.6c0.2-0.1,0.3-0.3,0.5-0.4c0.4-0.4,0.8-0.8,1.1-1.3 c0.6-0.9,0.9-1.9,0.9-3c0-1.6-0.6-3.1-1.7-4.1c-2.6,3.6-4.1,8.1-4.1,12.8v0.2c0,7.7,3.9,14.5,9.8,18.5c0.7-1.4,1.2-3.1,1.2-4.8 C12,32.5,9.5,28.8,6,26.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 100,
    height: 88,
    xlinkHref: "CE00E2D1.png",
    transform: "matrix(1 0 0 1 -21 -21)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003813775040835620040000014094958521124339617_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.4655,
    y1: 23.1074,
    x2: 42.5954,
    y2: 23.1074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#534BEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED34B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003813775040835620040000014094958521124339617_)"
    },
    d: "M23.1,30.7c-2.9,0-5.5-1.6-6.8-4.2 c-0.9-1.8-1.1-3.9-0.4-5.8c0.6-1.9,2-3.5,3.8-4.4c1.1-0.5,2.2-0.8,3.4-0.8c2.9,0,5.5,1.6,6.8,4.2c0,0.1,0.1,0.2,0.1,0.3 c0.5,1.1,1.5,1.8,2.6,1.9c0.1,0,0.3,0,0.4,0c1,0,2-0.4,2.6-1.2c0.3-0.4,0.8-0.8,1.3-1c0.5-0.3,1.1-0.4,1.7-0.4 c1.5,0,2.8,0.8,3.5,2.2c1,1.9,0.2,4.3-1.8,5.3c-0.5,0.3-1.1,0.4-1.7,0.4c-1.2,0-2.3-0.5-3.1-1.5C35,24.8,34,24.4,33,24.4 c-0.1,0-0.3,0-0.4,0c-1.2,0.1-2.2,0.9-2.6,1.9c-0.7,1.6-1.9,2.8-3.5,3.6C25.4,30.4,24.2,30.7,23.1,30.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtcodeySymbol);
export default __webpack_public_path__ + "static/media/artcodey-symbol.adbb05eac340ac6a22b305ae29410f36.svg";
export { ForwardRef as ReactComponent };